import e from "react";
var t = function () {
  return (t = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }).apply(this, arguments);
};
function r() {
  return (r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }).apply(this, arguments);
}
var n = _ref => {
    let {
      styles: t = {},
      ...n
    } = _ref;
    return e.createElement("svg", r({
      className: (t["ef-icon"] || "ef-icon") + " " + (t["ef-svg"] || "ef-svg"),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      width: "32",
      height: "32"
    }, n), e.createElement("path", {
      d: "M16 16a7 7 0 10-7-7 7 7 0 007 7zm0-11a4 4 0 11-4 4 4 4 0 014-4zm0 13c-7 0-13 4.61-13 7.5V29a1 1 0 001 1h24a1 1 0 001-1v-3.5c0-2.89-5.95-7.5-13-7.5zm0 3c5.63 0 9.63 3.39 10 4.58V27H6v-1.42C6.37 24.39 10.37 21 16 21z"
    }));
  },
  a = function (r) {
    var a = r.className,
      o = function (e, t) {
        var r = {};
        for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var a = 0;
          for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
        }
        return r;
      }(r, ["className"]);
    return e.createElement(n, t({
      className: ["ef-icon ef-svg", a].join(" ")
    }, o));
  };
a.displayName = "IconPersonOutline";
export default a;